import React from 'react';
import { Form, Button, Icon, Spin } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import I18n from '@src/i18n';
import FieldsValidation from '@components/Form/validationform/FieldsValidation';
import { TypesValidation } from '@src/helpers/Enums';
import IExecutionComponent from '../interfaces/IExecutionComponent';
import ImageRecognitionModalExecutionComponent from './ImageRecognitionModalExecutionComponent';
import styled from 'styled-components';

export interface IImageRecognitionExecutionProps extends IExecutionComponent {
  description: string;
  defaultValue: any[];
  configurationItems: any[];
  modelId: string;
  projectId: string;
  onChange: Function;
}

export interface IImageRecognitionExecutionState {
  imgRecognitionComponent: any;
  valid: boolean[];
  defaultValue: any[];
  file: any[];
  pdfImg: any,
  showModal: boolean;
  convertingPDF: boolean;
}

export default class ImageRecognitionExecutionComponent extends React.Component<IImageRecognitionExecutionProps, IImageRecognitionExecutionState> {
  constructor(props: IImageRecognitionExecutionProps) {
    super(props);
    this.state = {
      imgRecognitionComponent: [{ value: "" }],
      defaultValue: props.defaultValue,
      valid: [true],
      file: [],
      pdfImg: null,
      showModal: false,
      convertingPDF: false
    }
    this.handleToggleModal = this.handleToggleModal.bind(this)
    this.saveValues = this.saveValues.bind(this)

  }
  componentDidMount() {
    const { defaultValue } = this.state
    if (defaultValue && defaultValue.value && defaultValue.value.length > 0) {
      let newImgRecognitionComponent = defaultValue.value.map((v: any, i: any) => {
        return {
          value: v.path,
          recognitionInputs: v.recognitionInputs,
          userInputs: v.userInputs,
          file: defaultValue.fileList[i]
        }
      })
      this.setState({ imgRecognitionComponent: newImgRecognitionComponent, defaultValue: undefined })
    }
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.defaultValue === undefined && prevState.imgRecognitionComponent[0].value === '' && this.state.imgRecognitionComponent[0].value !== '')
      this.handleToggleModal()
  }
  //#region  START HANDLES 
  handleImgChange = (idx: any) => (evt: any, isLoading: boolean, fileUploaded: any) => {

    const newInputImg = this.state.imgRecognitionComponent.map((items: any, sidx: number) => {
      if (idx !== sidx) return items;
      return { ...items, value: evt, file: fileUploaded };
    });
    this.setState({convertingPDF: false})
    if (!['', null, undefined].includes(newInputImg[0].value) && newInputImg[0].value.toLowerCase().includes('.pdf')) {
      this.setState({convertingPDF: true})
      setTimeout(() => {
        const canvas = document.getElementById("pdfCanvas")
        if (canvas) {
          const myImage = canvas.toDataURL();
          newInputImg[0].pdfImg = myImage
          let valid = this.validationUpload(newInputImg, idx, isLoading)

          this.setState({ imgRecognitionComponent: newInputImg, valid: valid,convertingPDF: false }, () => {
            this.props.onChange({
              id: this.props.id,
              value: newInputImg.map((e: any) => e.value),
              validation: [!valid.includes(false)],
              file: newInputImg.map((e: any) => e.file),
              pdfImg: myImage.pdfImg
            });
          });
        }
      }, 5000)
    } else {
      // if (!['', null, undefined].includes(newInputImg[0].value)) {
        let valid = this.validationUpload(newInputImg, idx, isLoading)
        this.setState({ imgRecognitionComponent: newInputImg, valid: valid }, () => {
          this.props.onChange({
            id: this.props.id,
            value: newInputImg.map((e: any) => e.value),
            validation: [!valid.includes(false)],
            file: newInputImg.map((e: any) => e.file),
          });
        });
      // }
    }
  }

  handleRemovePhotos = (index: number) => async () => {
    let newInputImg = this.state.imgRecognitionComponent.filter((section: any, sindex: number) => index !== sindex)
    let valid = this.validationUpload(newInputImg, index, false)
    this.setState({
      imgRecognitionComponent: newInputImg,
      valid: valid
    });
    this.props.onChange({
      id: this.props.id,
      file: newInputImg.map((e: any) => e.file),
      validation: valid
    });

  }
  // deleteIcon(index: number) {
  //   return (
  //     <Icon
  //       style={{ color: 'red', marginLeft: '20px', cursor: "pointer" }}
  //       type="close"
  //       onClick={this.handleRemovePhotos(index)}
  //     />
  //   )
  // }

  validationUpload = (newInputImg: any, idx: number, isLoading: boolean) => {
    let valid = this.state.valid;
    if (isLoading || newInputImg[idx] === undefined) {
      valid[idx] = false
    } else {
      valid[idx] = newInputImg[idx].value !== "" ? true : false
    }
    return valid
  }

  handleDefaultValue(value: any, index: number) {
    if (value && value.fileList && value.fileList[index])
      return {
        value: value.value[index].path,
        fileList: value.fileList[index]
      }
    return undefined
  }

  handleToggleModal() {
    this.setState({ showModal: !this.state.showModal })
  }

  handleDelete() {
    document.querySelector('.anticon-delete') ? document.querySelector('.anticon-delete').click() : null;
  }

  saveValues(recognitionInputs: Array<number>, userInputs: Array<number>) {
    let value = this.state.imgRecognitionComponent[0].value
    this.setState({
      imgRecognitionComponent: [{
        value,
        recognitionInputs,
        userInputs
      }]
    }, () => {
      this.props.onChange({
        id: this.props.id,
        value: [{
          path: this.state.imgRecognitionComponent[0].value,
          recognitionInputs,
          userInputs
        }]
      })
      this.handleToggleModal()
    })
  }

  render() {
    const { showModal, convertingPDF } = this.state;
    return (
      <>
        <Form>
          <p>{this.props.description}</p>
          <FormItem>
            {this.state.imgRecognitionComponent.map((items: any, index: number) => (
              <UploadWrapper key={`${this.props.id}_pho_${index}`}>
                <FieldsValidation
                  type={TypesValidation.IMAGE}
                  messageValidation={I18n.l("common.fieldRequired")}
                  handleOnChange={this.handleImgChange(index)}
                  validation={this.state.valid[index]}
                  defaultValue={this.handleDefaultValue(this.state.defaultValue, index)}
                  onRemoveImage={this.handleRemovePhotos}
                />
                {items.value !== '' && <>
                  <Button
                    onClick={this.handleToggleModal}
                    className="goepik-btn-border-main-withoutbold"
                  >{I18n.l("common.edit")}</Button>
                  <Button
                    onClick={this.handleDelete}
                    style={{ color: 'red' }}
                    className="goepik-btn-border-main-withoutbold"
                  >{I18n.l("common.delete")}</Button>
                </>}
              </UploadWrapper>
            ))}
            {convertingPDF && <PdfLoadingConainer>{I18n.l('imageRecognition.modalExecution.convertingPdf')}</PdfLoadingConainer>}
          </FormItem>
          {/* {this.props.repeat &&
            < Button
              onClick={this.handleAddImg}
              style={{ marginLeft: '-15px', fontWeight: 'bold' }}
              className="goepik-btn-border-main-withoutbold"
            >
              <Icon type="plus" /> {I18n.l("common.addNew")}
            </Button>
          } */}

        </Form>
        {showModal && <ImageRecognitionModalExecutionComponent
          isVisible={showModal}
          image={this.state.imgRecognitionComponent[0].value.toLowerCase().includes('.pdf') ? this.state.imgRecognitionComponent[0].pdfImg : this.state.imgRecognitionComponent[0].value}
          qtdAPI={this.state.imgRecognitionComponent[0].recognitionInputs}
          qtd={this.state.imgRecognitionComponent[0].userInputs}
          onSave={this.saveValues}
          configurationItems={this.props.configurationItems}
          onToggleModal={this.handleToggleModal}
          modelId={this.props.modelId}
          projectId={this.props.projectId}
        />}
      </>
    );
  }
}

const UploadWrapper = styled.div`
  display: flex
`;

const PdfLoadingConainer = styled.div`
  display: flex;
  align-items: center;
`;